import { render, staticRenderFns } from "./wtInstagramAsset.vue?vue&type=template&id=6561ae23&"
import script from "./wtInstagramAsset.vue?vue&type=script&lang=js&"
export * from "./wtInstagramAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports